import { _, React, classNames, withStyles, StyledProps } from '@api'
import { Typography } from '@material-ui/core'

const spacingUnit = 8

const styles = (theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  block: {
    backgroundColor: `rgb(252, 130, 180)`
  }
})

interface MyProps extends StyledProps {
  multiplier: number
}

@(withStyles as any)(styles)
export class Spacings extends React.Component<MyProps> {
  static defaultProps = {
    multiplier: 1
    }

  render() {
    const {className, classes, multiplier} = this.props;

    return (
      <div className={classNames(className, classes.container)}>
        <div className={classes.block} style={{width: spacingUnit * multiplier, height: spacingUnit * multiplier}}/>
        <Typography>{`${multiplier} X`}</Typography>
        <Typography variant={'caption'}>{`(${spacingUnit * multiplier}px)`}</Typography>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/ui/misc/Spacings.tsx